<template>
  <v-card flat class="pa-3">
    <h4>Logdetails — {{ log.endpoint }}</h4>
    <p>
      <strong>ID:</strong> {{ log.id }} | <strong>Organisation:</strong>
      {{ log.organisationName }} | <strong>SBM Profile:</strong>
      {{ log.sbmProfileName || "-" }} | <strong>Country:</strong>
      {{ log.country }} | <strong>Status:</strong>
      {{ log.responseStatus || "-" }} | <strong>Time:</strong>
      {{ log.timestamp }} | <strong>Source:</strong> {{ log.sourceService }} |
      {{ log.method }} | <strong>Method:</strong> {{ log.method }} |
      <strong>CorrelationId:</strong> {{ log.correlationId || "-" }}
    </p>

    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>Request</v-tab>
      <v-tab>Response</v-tab>
      <v-tab>Error</v-tab>
      <v-tab>Extra</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <RequestSummary
          v-if="parsedRequest"
          :request="parsedRequest"
        />

        <v-divider class="my-3" />

        <details>
          <summary>Raw request (JSON)</summary>
          <pre class="json">{{ formatJson(log.requestBody) }}</pre>
        </details>
      </v-tab-item>

      <v-tab-item>
        <ResponseSummary
          v-if="parsedResponse && parsedResponse.results"
          :response="parsedResponse"
        />

        <v-divider class="my-3" />

        <details>
          <summary>Raw response (JSON)</summary>
          <pre class="json">{{ formatJson(log.responseBody) }}</pre>
        </details>
      </v-tab-item>

      <v-tab-item>
        <pre class="json">{{ log.errorStackTrace || "Geen error" }}</pre>
      </v-tab-item>

      <v-tab-item>
        <pre class="json">{{ extraInfo }}</pre>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RequestSummary from "./RequestSummary.vue";
import ResponseSummary from "./ResponseSummary.vue";

export default {
  name: "LogDetails",
  components: {
    RequestSummary,
    ResponseSummary,
  },
  props: { log: Object },
  data() {
    return { tab: 0 };
  },
  computed: {
    parsedRequest() {
      if (!this.log.requestBody) return null;
      try {
        return JSON.parse(this.log.requestBody);
      } catch {
        return null;
      }
    },
    parsedResponse() {
      if (!this.log.responseBody) return null;
      try {
        return JSON.parse(this.log.responseBody);
      } catch {
        return null;
      }
    },
    extraInfo() {
      const formatTs = (ts) => {
        if (!ts) return null;
        const d = new Date(ts);
        return d.toISOString().slice(0, 19);
      };

      return {
        OrganisationId: this.log.organisationId,
        RequestTimestamp: formatTs(this.log.requestTimestamp),
        ResponseTimestamp: formatTs(this.log.responseTimestamp),
        MatchedRules: this.log.matchedRules,
        SBMProfileId: this.log.sbmProfileId,
        SalesOrganisation: this.log.salesOrganisation,
        QueryParameters: this.log.queryParameters,
      };
    },
  },
  methods: {
    formatJson(str) {
      if (!str) return "—";
      try {
        return JSON.stringify(JSON.parse(str), null, 2);
      } catch {
        return str;
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.json {
  background: #1e1e1e;
  color: #dcdcdc;
  padding: 8px;
  border-radius: 6px;
  white-space: pre-wrap;
  font-family: monospace;
  margin-top: 8px;
  font-size: 12px;
}
</style>
